<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              md="12"
            >
              <v-form ref="form_all">
                <v-tabs
                  centered
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-account-outline
                    </v-icon>Информация
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-domain
                    </v-icon>Содержание
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-text-box-outline
                    </v-icon>Документы
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-history
                    </v-icon>История статусов
                  </v-tab>
                  <v-tab-item>
                    <v-row
                      dense
                      class="justify-center"
                    >
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              Общая информация
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row
                                dense
                                class="justify-center"
                              >
                                <v-col cols="6">
                                  <v-text-field
                                    v-model="form.created"
                                    label="Дата платежа"
                                    readonly
                                  />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model="form.updated"
                                    label="Дата статуса"
                                    readonly
                                  />
                                </v-col>
                              </v-row>
                              <v-row
                                dense
                                class="justify-center"
                              >
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="form.number"
                                    label="номер платежа"
                                    readonly
                                  />
                                </v-col>
                                <v-col cols="12">
                                  <v-select
                                    v-model="form.state"
                                    label="Дата статуса"
                                    :items="select.state"
                                    readonly
                                  />
                                </v-col>
                              </v-row>
                              <v-row
                                v-if="form.order_item"
                                dense
                                class="justify-center"
                              >
                                <v-col cols="4">
                                  <v-text-field
                                    v-model="form.order_item.sum.full"
                                    label="Сумма платежа"
                                    readonly
                                  />
                                </v-col>
                                <v-col cols="4">
                                  <v-text-field
                                    v-model="form.order_item.sum.recipient"
                                    label="Сумма получателя"
                                    readonly
                                  />
                                </v-col>
                                <v-col cols="4">
                                  <v-text-field
                                    v-model="form.order_item.sum.comission"
                                    label="Комиссия"
                                    readonly
                                  />
                                </v-col>
                              </v-row>
                              <v-row
                                v-else
                                dense
                                class="justify-center"
                              >
                                <v-col cols="4">
                                  <v-text-field
                                    v-model="form.sum"
                                    label="Сумма платежа"
                                    readonly
                                  />
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel v-if="form.point">
                            <v-expansion-panel-header>
                              Точка обслуживания
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-row
                                dense
                                class="justify-center"
                              >
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="form.point.number"
                                    label="Номер точки"
                                    readonly
                                  />
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="form.point.name"
                                    label="Наименование точки"
                                    readonly
                                  />
                                </v-col>
                                <v-col
                                  v-if="form.point.place_item"
                                  cols="12"
                                >
                                  <v-text-field
                                    v-model="form.point.place_item.name"
                                    label="Наименование места обслуживания"
                                    readonly
                                  />
                                </v-col>
                                <v-col
                                  v-if="form.point.place_item"
                                  cols="12"
                                >
                                  <v-text-field
                                    v-model="form.point.place_item.address"
                                    label="Адрес"
                                    readonly
                                  />
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="form.order_item.creator.full_name"
                                    label="Пользователь"
                                    readonly
                                  />
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel v-if="form.payments">
                            <v-expansion-panel-header>
                              Средство платежа
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div
                                v-for="(payment,index) in form.payments.filter(a=>a.sum > 0)"
                                :key="&quot;ppp&quot; + index"
                              >
                                <v-divider />
                                <v-card>
                                  <v-card-text>
                                    <v-row>
                                      <v-col>
                                        {{ meansOfPayment(payment.payment_refund) }}
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      dense
                                      class="justify-center"
                                    >
                                      <v-col cols="4">
                                        <v-select
                                          v-model="payment.type"
                                          label="Средство платежа"
                                          readonly
                                          :items="select.type"
                                        />
                                      </v-col>
                                      <v-col cols="4">
                                        <v-text-field
                                          v-if="payment.data"
                                          v-model="payment.data.date_time"
                                          label="Дата статуса"
                                          readonly
                                        />
                                      </v-col>
                                      <v-col cols="4">
                                        <v-text-field
                                          v-model="payment.sum"
                                          label="Сумма платежа"
                                          readonly
                                        />
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      v-if="payment.data"
                                      dense
                                      class="justify-center"
                                    >
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="payment.data.rrn"
                                          label="RRN"
                                          readonly
                                        />
                                      </v-col>
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="payment.data.tid"
                                          label="TID"
                                          readonly
                                        />
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      v-if="payment.data"
                                      dense
                                      class="justify-center"
                                    >
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="payment.data.pan"
                                          label="Номер карты"
                                          readonly
                                        />
                                      </v-col>
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="payment.data.card_name"
                                          label="Платежная система"
                                          readonly
                                        />
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      v-if="payment.data"
                                      dense
                                      class="justify-center"
                                    >
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="payment.data.holdername"
                                          label="Держатель карты"
                                          readonly
                                        />
                                      </v-col>
                                      <v-col cols="6">
                                        <v-text-field
                                          v-model="payment.data.auth_code"
                                          label="Код авторизации"
                                          readonly
                                        />
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-card>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-data-table
                          :items="form.items"
                          :headers="[
                            {
                              text: 'Наименование',
                              value: 'name',
                            },
                            {
                              text: 'Получатель',
                              value: 'attributes.recipient_name',
                            },
                            {
                              text: 'Цена',
                              value: 'amount',
                            },
                            {
                              text: 'Количество выбранное',
                              value: 'count_wish',
                            },
                            {
                              text: 'Количество оплаченное ',
                              value: 'count',
                            },
                          ]"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                          @click:row="(a) => {selected.current_item = a}"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.type="{ item }">
                            <span v-if="item && item.type == 1 && !item.comission">
                              Услуга
                            </span>
                            <span v-if="item.comission">
                              Комиссия
                            </span>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>

                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-data-table
                          v-if="selected.current_item && selected.current_item.attributes"
                          :items="selected.current_item.settings"
                          :headers="[
                            {value: 'description', text: 'Описание', width: 300},
                            {value: 'value', text: 'Значение', width: 150},
                          ]"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:item.description="{item}">
                            <v-text-field
                              v-model="item.description"
                              readonly
                            />
                          </template>

                          <template v-slot:item.value="{item}">
                            <v-text-field
                              v-if="item.type == 0"
                              v-model="selected.current_item.attributes[item.key]"
                              readonly
                            />
                            <v-checkbox
                              v-if="item.type == 1"
                              v-model="selected.current_item.attributes[item.key]"
                              readonly
                            />
                            <v-select
                              v-if="item.type == 2"
                              v-model="selected.current_item.attributes[item.key]"
                              :items="item.values"
                              readonly
                            />
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-expansion-panels>
                          <v-expansion-panel v-if="form.cheque_text">
                            <v-expansion-panel-header>
                              Кассовый чек (приход)
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div v-html="form.cheque_text" />
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel
                            v-for="(payment, index) in form.payments "
                            :key="index"
                          >
                            <v-expansion-panel-header v-if="payment.data && payment.data.slip">
                              {{ paymentRefund(payment.payment_refund) }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content v-if="payment.data && payment.data.slip">
                              <pre>{{ payment.data.slip }}</pre>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel v-if="form.reverse_cheque_text">
                            <v-expansion-panel-header>
                              Кассовый чек (возврат)
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <div v-html="form.reverse_cheque_text" />
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel v-if="getReverseDataSlip(form.payments)">
                            <v-expansion-panel-header>
                              Слип чек (возврат)
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <pre>{{ form.payments[0].reverse_data.slip }}</pre>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-data-table
                          disable-sort
                          :items="form.state_history"
                          :headers="[
                            {value: 'state', text: 'Статус'},
                            {value: 'date', text: 'Дата'},
                            {value: 'description', text: 'Описание'}
                          ]"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:item.state="{item}">
                            {{ dict.state[item.state] }}
                          </template>
                          <template v-slot:item.date="{item}">
                            {{ format_with_time(item.date) }}
                          </template>
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="6"
              md="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              v-if="false"
              cols="6"
              md="3"
              class="text-right"
            >
              <v-btn
                color="primary"
                class="ml-auto"
                @click="save"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    props: ['paymentList'],
    data: () => ({
        datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
        selected: {
            current_item: null
        },
      form: {
          sum: {},
          point: null,
          order_item: {
              creator: {},
              sum: {}
          }
      },
      dict: {
        state: {
          0: 'Новый',
          1: 'Обработка ККТ',
          2: 'Обработан ККТ',
          3: 'Обработка ПС',
          4: 'Обработан ПС',
          5: 'Ошибка ККТ',
          6: 'Ошибка ПС',
          7: 'Отозван',
          8: 'Завершен',
          9: 'Ошибка сети',
          10: 'Отмена банковской операции',
          11: 'Банковская операция отменена'
        }
      },
      payment_list: '/api/payment/list',
      select: {
          state: [
             { value: 0, text: 'Новый' },
          { value: 1, text: 'Обработка ККТ' },
          { value: 2, text: 'Обработан ККТ' },
          { value: 3, text: 'Обработка ПС' },
          { value: 4, text: 'Обработан ПС' },
          { value: 5, text: 'Ошибка ККТ' },
          { value: 6, text: 'Ошибка ПС' },
          { value: 7, text: 'Отозван' },
          { value: 8, text: 'Завершен' },
          { value: 9, text: 'Ошибка сети' },
          { value: 10, text: 'Отмена банковской операции' },
          { value: 11, text: 'Банковская операция отменена' }
          ],
          type: [
              { value: 0, text: 'Наличные' },
            { value: 1, text: 'Банковская карта' },
            { value: 2, text: 'СБП' },
          ]
      }
    }),
    computed: {
        max_date: function () {
            return moment().format('YYYY-MM-DD')
        },
    },
    mounted: function () {
      var id = this.$route.query.id
      if (id) { this.load(id) }
    },
    methods: {
      load: function (id) {
        this.axios.post(this.paymentList, { id: id })
          .then(response => {
            if (!response.data.error && response.data.data.length > 0) {
              this.form = response.data.data[0]
              this.form.created = moment(this.form.created).format('DD.MM.YYYY HH:mm:ss')
              this.form.updated = moment(this.form.updated).format('DD.MM.YYYY HH:mm:ss')
              this.form.order_item = this.form.order_item || { creator: {} }
              this.form.order_item.sum = this.form.order_item.sum || { full: this.form.sum }
              this.form.order_item.creator.full_name = this.form.order_item.creator.surname + ' ' + this.form.order_item.creator.name + ' ' + this.form.order_item.creator.patronymic
              this.form.payments = this.fillEmptyPayments(this.form.payments)
              this.form.chequeText = response.data.chequeText

              for (const x in this.form.payments) {
                  if (this.form.payments[x].data && this.form.payments[x].data.date) {
                      this.form.payments[x].data.date_time = moment(this.form.payments[x].data.date).format('DD.MM.YYYY') + ' ' + this.form.payments[x].data.time
                  } else {
                      if (this.form.payments[x].data) { this.form.payments[x].data.date_time = this.form.payments[x].data.operation_date }
                  }
              }
            } else {
              this.$store.commit('snackbar', response.data.data)
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', e)
          })
      },
      fillEmptyPayments (payments) {
          if (!payments || payments.length < 1) {
            payments = [{ type: 0, reverse_data: null }]
          }
        return payments
      },
      format_with_time: function (date) {
          return moment(date).format('DD.MM.YYYY HH:mm:ss')
      },
      getReverseDataSlip (payments) {
        if (payments.length > 0) {
          if (payments[0].reverse_data) {
            if (payments[0].reverse_data.slip) {
              return true
            }
          }
        }
        return false
      },
      save: function () {
          let url = '/api/payment/save'
          if (!this.form.id) {
              url = '/api/payment/create'
          }
          this.axios.post(url, this.form)
          .then(response => {
            if (!response.data.error) {
              this.$router.go(-1)
            } else {
              this.$store.commit('snackbar', response.data.data)
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', e)
          })
      },
      meansOfPayment (paymentStatus) {
        let retText = 'Оплата'
        switch (paymentStatus) {
          case 0: retText = 'Оплата'
            break
          case 1: retText = 'Отмена'
            break
          case 2: retText = 'Доплата'
            break
        }
        return retText
      },
      paymentRefund (paymentStatus) {
        let retText = 'Слип чек (оплата)'
        switch (paymentStatus) {
          case 0: retText = 'Слип чек (оплата)'
          break
          case 1: retText = 'Слип чек (отмена)'
                break
          case 2: retText = 'Слип чек (доплата)'
                break
        }
        return retText
      }
    },
  }
</script>
